module.exports = __webpack_public_path__ + "img/tech1.b89cef0.png";